export const EProProductType = {
  "0": "UNKNOWN",
  "1": "FLIGHT",
  "2": "HOTEL",
  "3": "TRANSFER",
  "4": "RENT_A_CAR",
  "5": "HOTEL_CONTENT",
  "6": "PAYMENT",
  "7": "INSURANCE",
  "-1": "ALL"
};

export const EProProviderType = {
  "0": "UNKNOWN",
  "1": "STANDART",
  "2": "GDS",
  "3": "CHARTER",
  "-1": "ALL"
};

export const EProChannelType = {
  "0": "UNKNOWN",
  "1": "SALE",
  "2": "CHANNEL_MANAGER",
  "-1": "ALL"
};

export const EProSalesChannelType = {
  "0": "UNKNOWN",
  "1": "RETAIL",
  "2": "WHOLESALE",
  "-1": "ALL"
};

export const EProImplementationType = {
  "0": "UNKNOWN",
  "1": "FLIGHT_THY",
  "2": "FLIGHT_PGS",
  "3": "FLIGHT_IFLY",
  "4": "FLIGHT_TRAVELPORT",
  "5": "FLIGHT_CORENDON",
  "6": "FLIGHT_GENIUS",
  "7": "FLIGHT_EUROWINGS",
  "8": "FLIGHT_TRAVELFUSION",
  "9": "FLIGHT_TOURVISIO",
  "10": "FLIGHT_IFLY_NDC",
  "11": "FLIGHT_THY_PREMIUM",
  "12": "FLIGHT_FARELOGIX",
  "13": "FLIGHT_DELTAPAX",
  "14": "FLIGHT_AER",
  "15": "FLIGHT_WORLD_TICKET",
  "16": "FLIGHT_PRIBAS",
  "17": "FLIGHT_AJET",
  "18": "FLIGHT_TRAVELPORT_NDC",
  "19": "FLIGHT_XMLAGENCY",
  "20": "FLIGHT_AVTRA",
  "101": "HOTEL_IATI",
  "102": "HOTEL_PAXIMUM",
  "103": "HOTEL_ODAMAX",
  "104": "HOTEL_EXPEDIA",
  "105": "HOTEL_GTS",
  "106": "HOTEL_CM_HOTEL_RUNNER",
  "107": "HOTEL_CM_VERTICAL_BOOKING",
  "108": "HOTEL_RATEHAWK",
  "109": "HOTEL_TRAVELGATEX",
  "110": "HOTEL_JUNIPER",
  "201": "TRANSFER_GTS",
  "202": "TRANSFER_PAXDRIVE",
  "301": "RENT_A_CAR_PANDORA",
  "401": "HOTEL_CONTENT_IATI",
  "402": "HOTEL_CONTENT_GIATA",
  "403": "HOTEL_CONTENT_EXPEDIA",
  "501": "PAYMENT_GETNET",
  "502": "PAYMENT_SOFORT",
  "503": "PAYMENT_IDEAL",
  "504": "PAYMENT_ENETT",
  "505": "PAYMENT_STRIPE",
  "601": "INSURANCE_BATTLEFACE",
  "-1": "ALL"
};

export const EProEodType = {
  "0": "UNKNOWN",
  "1": "ONLINE",
  "2": "BATCH",
  "-1": "ALL"
};

export const EProLoginStatus = {
  "0": "UNKNOWN",
  "1": "AUTHORIZED",
  "2": "UNAUTHORIZED",
  "3": "SUCCESS",
  "4": "FAIL",
  "-1": "ALL"
};